module.exports = __webpack_public_path__ + "static/media/mantis_religiosa.a3c834ef.jpg";